import React from "react";
import { FaMapMarkerAlt, FaEnvelope, FaPhoneAlt, FaClock } from "react-icons/fa";
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from "react-icons/fa";
import "../CustomCSS/ContactUs.css";

const ContactUs = () => {
  return (
    <section id="contactus" className="contactus-section">
      <div className="contactus-container">
        {/* Left Side - Contact Info */}
        <div className="contactus-info">
          <h3 className="sub-heading">Contact Info</h3>

          <div className="info-item">
            <div className="icon-circle">
              <FaMapMarkerAlt />
            </div>
            <div>
              <h4>Our Address</h4>
              <p>
                D.No.23-3-253, RTC Bus Stand Back Side, Vinayaka Swamy Temple
                Lane, Sodhan Nagar, Nellore-524001
              </p>
            </div>
          </div>

          <div className="info-item">
            <div className="icon-circle">
              <FaEnvelope />
            </div>
            <div>
              <h4>Email Us</h4>
              <p>
                <a href="mailto:supathamayurveda@gmail.com" className="contact-link">
                  supathamayurveda@gmail.com
                </a>
              </p>
            </div>
          </div>

          <div className="info-item">
            <div className="icon-circle">
              <FaPhoneAlt />
            </div>
            <div>
              <h4>Call Us</h4>
              <p>
                <a href="tel:+918019108877" className="contact-link">
                  +91 80191 08877
                </a>
              </p>
            </div>
          </div>

          <div className="info-item">
            <div className="icon-circle">
              <FaClock />
            </div>
            <div>
              <h4>Working Hours</h4>
              <p>Mon - Sun | 9:00 AM - 8:00 PM</p>
            </div>
          </div>
        </div>
      </div>

      {/* Map Section */}
      <div className="map-container">
        <iframe
          title="clinic-location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3712.823818628218!2d79.97818!3d14.441472899999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a4cf30030ebdad9%3A0x3a3bc58678831cf8!2sSUPATHAM%20Ayurvedic%20Hospital!5e1!3m2!1sen!2sin!4v1758456818608!5m2!1sen!2sin"
          width="100%"
          height="400"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
        ></iframe>
      </div>

      {/* Bottom Bar */}
      <div className="bottom-bar">
        <p>© 2025 Ayurvedham. All Rights Reserved. | Disclaimer</p>
        <div className="social-icons">
          <a href="https://facebook.com" target="_blank" rel="noreferrer">
            <FaFacebook />
          </a>
          <a href="https://twitter.com" target="_blank" rel="noreferrer">
            <FaTwitter />
          </a>
          <a href="https://instagram.com" target="_blank" rel="noreferrer">
            <FaInstagram />
          </a>
          <a href="https://linkedin.com" target="_blank" rel="noreferrer">
            <FaLinkedin />
          </a>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
